import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ModalItemProps {
  title: React.ReactNode;
  children: React.ReactNode;
  error?: string;
}

export function ModalInput({ title, children, error }: ModalItemProps) {
  return (
    <div>
      <label className="flex items-center gap-1 text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
        {title} <span className="text-red-500">*</span>
      </label>

      {children}

      {error && (
        <div className="mt-2 flex items-center gap-2 text-red-600 dark:text-red-400 text-xs">
          <ExclamationTriangleIcon className="w-4 h-4 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
